module.exports = __webpack_public_path__ + "static/media/bison-burger-fr.f66671ff.jpg";